import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next'
import { isFontSelectorOpened } from '../../selectors/entities/ui';
import {
  getSelectedEmbroyderyText,
  getSelectedEmbroyderyFont,
  getSelectedEmbroyderyColor,
  getSelectedFabricAttr,
} from '../../selectors/entities/general';
import Canvas from "../ui/Canvas";
import { FontSelector } from '../FontSelector';


class BuilderCanvas extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    const {
      fontSelectorOpened,
      embroyderyText,
      embroyderyFont,
      embroyderyColor,
      selectedFabric,
      fontSelectorSize,
    } = this.props;
    return (
      <div className="b-config-wrapper2">
        {fontSelectorOpened &&
          <FontSelector
            font={embroyderyFont}
            text={embroyderyText}
            color={embroyderyColor}
            fabricArticle={selectedFabric}
            size={fontSelectorSize}
          />
        }
        <Canvas {...this.props} />
      </div>
    );
  }
}

BuilderCanvas.propTypes = {
  updateRender: PropTypes.object.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  type: PropTypes.oneOf(['builder', 'preview', 'xsmall']),
  fontSelectorOpened: PropTypes.bool,
  embroyderyText: PropTypes.string,
  embroyderyFont: PropTypes.string,
  embroyderyColor: PropTypes.string,
  selectedFabric: PropTypes.any,
  fontSelectorSize: PropTypes.string,
};

function mapStateToProps(state, ownProps) {

  return {
    updateRender: state.render,
    zoomMode: state.ui.zoomMode,
    fontSelectorOpened: isFontSelectorOpened(state),
    embroyderyText: getSelectedEmbroyderyText(state),
    embroyderyFont: getSelectedEmbroyderyFont(state),
    embroyderyColor: getSelectedEmbroyderyColor(state),
    selectedFabric: getSelectedFabricAttr(state),
    ...ownProps,
  };
}

BuilderCanvas.whyDidYouRender = false;

export default connect(
  mapStateToProps,
  null
)(withTranslation()(BuilderCanvas));
